import { useTranslation } from 'react-i18next';
import QrBlock from '../ui/QrBlock';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="relative bg-brand-paper border-t border-brand-gold/20">
      <div className="mx-auto max-w-5xl px-6 py-10 grid grid-cols-1 md:grid-cols-[1fr_auto] gap-8 items-center">
        <div className="text-center md:text-center md:pl-24">
          <div className="flex justify-center">
            <img 
              src="/images/footer_image.png" 
              alt={t('footer.names')} 
              className="h-16 sm:h-20 md:h-24 w-auto object-contain"
            />
          </div>
          <div className="mt-2 flex items-center justify-center gap-3 text-brand-gold">
            <span aria-hidden="true" className="block h-px w-8 bg-brand-gold/60" />
            <p className="font-serif italic tracking-[0.18em] text-sm">
              {t('footer.date')}
            </p>
            <span aria-hidden="true" className="block h-px w-8 bg-brand-gold/60" />
          </div>
          <p className="mt-1 font-sans text-[0.65rem] tracking-widest uppercase text-brand-ink/70">
            {t('footer.venue')}
          </p>
        </div>
        <div className="justify-self-center md:justify-self-end">
          <QrBlock />
        </div>
      </div>
      <div className="border-t border-brand-gold/15">
        <div className="mx-auto max-w-5xl px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-[0.65rem] uppercase tracking-widest font-sans text-brand-ink/60">
          <p>{t('footer.copyright')}</p>
          <p>{t('footer.tagline')}</p>
        </div>
      </div>
    </footer>
  );
}
